export default __webpack_public_path__ + "static/media/television.537ba6a5.png";